import { dialog } from "../../nq-component";
import { findObjectUseCase } from "../../usecases/object";
import generateForgotPassEmail from "./utils/generateForgotPassEmail";
import { restUseCase } from "../../usecases/rest";
import { resetPasswordUseCase } from "../../usecases/user";

class ForgotPasswordPresenter {
  constructor(view, findObjectUseCase, restUseCase, resetPasswordUseCase) {
    this.view = view;
    this.findObjectUseCase = findObjectUseCase;
    this.restUseCase = restUseCase;
    this.resetPasswordUseCase = resetPasswordUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  showImage() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src="/emailLoading2.gif"
              alt="loading"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <p style={{ color: "#D18237" }}>Sending email... Please wait...</p>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async submit() {
    const { email } = this.change;
    const query = {
      where: { email: email },
    };

    if (!email || !email.trim()) {
      this.view.showError("Please enter a valid email address.");
      return;
    }

    try {
      this.showImage();
      const response = await resetPasswordUseCase().execute(email,{timeout:0});
      console.warn("matchedUser",response);

      if (!response) {
        this.view.showError("No account found with this email address.");
      }

      dialog.close();
      this.view.showSuccess(response.message);  
      
    } catch (error) {
      console.error("Password reset error:", error);
      this.view.showError(
        error.message || "An error occurred while resetting your password.",
      );
    }
  }

  // async sendForgotEmail(userId, email) {
  //   const method = "POST";
  //   const path = "forgot";

  //   const obj = {
  //     to: email,
  //     subject: "Forgot Password",
  //     body: generateForgotPassEmail(userId),
  //   };

  //   try {
  //     this.showImage();
  //     const response = await restUseCase().execute(method, path, { body: obj });

  //     if (response) {
  //       dialog.close();
  //       this.view.setState({ object: this.object });
  //       this.view.showSuccess(response.message);
  //     }
  //   } catch (error) {
  //     console.error("Error sending email:", error);
  //     this.view.showError("Invalid Email")
  //   }
    
  // }
}

export default ForgotPasswordPresenter;
